<template>
  <div class="daily-reward" :class="cssType">
    <div class="daily-reward-title" :class="locale"></div>
    <div class="daily-reward-desc">
      {{ $t('poolParty.dailyReward.desc') }}
    </div>
    <CountDown :realTime="globalState.realTime" class="root-count-down" />
    <div class="btn-wrap">
      <PPButton type="blue" @click="handleShowRecord">
        {{ $t('poolParty.record.title') }}
      </PPButton>
      <PPButton type="yellow" @click="handleShowRewardDetail">
        {{ $t('poolParty.record.detailTitle') }}
      </PPButton>
    </div>
    <div class="list">
      <div class="item" :class="{ yellow: [3, 7].includes(item.dayIndex) }" v-for="item in globalConf.dailyRewardConfigList" :key="item.dayIndex">
        <div class="item-title">
          {{ $t('poolParty.dailyReward.day', { day: item.dayIndex }) }}
        </div>
        <PPButton v-if="item.status === 2" class="item-btn" type="gray" disabled>
          {{ $t('poolParty.btnReceived') }}
        </PPButton>
        <PPButton v-else-if="item.status === 1" class="item-btn" type="green" @click="receiveAllRewards">
          {{ $t('poolParty.btnCanReceive') }}
        </PPButton>
        <PPButton v-else class="item-btn" type="blue" @click="goRecharge">
          {{ $t('poolParty.goRecharge') }}
        </PPButton>
      </div>
    </div>
    <RewardDialog v-model="rewardDialogVisible" :prop-list="propList" :title="$t('accum.rewardsAllDialog.title')" />
    <RecordDialog v-model="recordDialogVisible" />
    <RewardDetailDialog v-model="rewardDetailDialogVisible" />
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { inject, ref } from 'vue'
import PoolPartyActApi from '@/config/poolPartyActApi'
import { toastService } from '@/utils/toastService'
import { formatReceiveAllRewardsToast, formatPropList } from '../../utils/receiveReward'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import PPButton from '../PPButton/index.vue'
import RecordDialog from '@/views/act/poolParty/components/Dialog/RecordDialog/index.vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import RewardDialog from '../Dialog/RewardDialog/index.vue'
import RewardDetailDialog from '../Dialog/RewardDetailDialog/index.vue'
import CountDown from '../CountDown/index.vue'
import { useLog } from '@/composables/useLog'
const log = useLog()
const store = useStore()
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const globalConf = inject('globalConf')
const globalState = inject('globalState')
const refreshUserDetail = inject('refreshUserDetail')
const router = useRouter()
// const statusMap = {
//   0: '未达标',
//   1: '已达标未领取',
//   2: '已领取',
// }

// const buttonTextMap = {
//   0: '未达标',
//   1: '领取全部',
//   2: '已领取',
// }

const rewardDialogVisible = ref(false)
const propList = ref([])
const receiveAllRewards = async () => {
  const res = await PoolPartyActApi.receiveAllRewards()
  const result = formatPropList(res, globalConf.value.dailyRewardConfigList)
  propList.value = result
  rewardDialogVisible.value = true
  try {
    log.track('act_pp_receive_daily_rewards', { v1: res.dailyDayIndexList.join(','), v2: res.accumulateRewardCodeList.join(','), v3: res.activityPropList.map(item => item.propId).join(',') })
  } catch(error) {
    console.error(error)
  }
  await refreshUserDetail()
}

const rewardDetailDialogVisible = ref(false)
const handleShowRewardDetail = () => {
  rewardDetailDialogVisible.value = true
}

const recordDialogVisible = ref(false)
const handleShowRecord = () => {
  if(!store.state.cpUserInfo.cpUserId || !store.state.cpUserInfo.token) {
    toastService.show(t('login.tips'))
    return
  }
  log.track('act_pp_record')
  recordDialogVisible.value = true
}

const goRecharge = () => {
  log.track('act_pp_recharge')
  const resolved = router.resolve({ name: 'Payment' })
  window.open(resolved.href, '_blank')
}
</script>

<style scoped lang='less' src='./pc_style.less'></style>
<style scoped lang='less' src='./mobile_style.less'></style>
